import { Logo } from "../ui/logo";
import { Spinner } from "../ui/spinner";

export function FullPageLoader() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas">
      <div className="flex flex-col items-center gap-5">
        <Logo />
        <Spinner className="size-6 text-brand" label="Loading Eduleo" />
      </div>
    </div>
  );
}
